import { List } from 'elements/react-admin/List'
import React from 'react'
import { UtilityTariffCatalogPageChrome } from './UtilityTariffCatalogPageChrome'

export type UtilityTariffCatalogListProps = React.ComponentProps<typeof List> & {
  heading?: string | React.ReactElement | false
  catalogFilter: React.ReactElement
  catalogToolbar?: {
    showCreateButton?: boolean
    createButtonLabel?: string
    searchBarPlaceholder?: string
    hasSearch?: boolean
  }
}

export const UtilityTariffCatalogList = ({
  heading,
  catalogFilter,
  catalogToolbar = {},
  children,
  basePath,
  ...listProps
}: UtilityTariffCatalogListProps) => {
  const { showCreateButton, createButtonLabel, searchBarPlaceholder, hasSearch = true } = catalogToolbar
  const { options: listOptions, ...restListProps } = listProps

  return (
    <List
      {...restListProps}
      basePath={basePath}
      options={{
        ...(listOptions || {}),
        list: {
          ...((listOptions as { list?: Record<string, unknown> } | undefined)?.list || {}),
          subtitle: null,
        },
      }}
      filters={false}
      actions={null}
      showNoResultsPage={false}
      hasCreate={false}
      hasSearch={false}
      title={
        <UtilityTariffCatalogPageChrome
          heading={heading}
          catalogFilter={catalogFilter}
          showCreateButton={showCreateButton}
          createButtonLabel={createButtonLabel}
          basePath={basePath}
          searchBarPlaceholder={searchBarPlaceholder}
          hasSearch={hasSearch}
        />
      }
    >
      {children}
    </List>
  )
}
